import React from 'react';
import { Building2, Zap, Briefcase, ShieldCheck } from 'lucide-react';
import { useTranslations } from '../hooks/useTranslations';
export function ValueProposition() {
  const {
    t
  } = useTranslations();
  const features = [{
    icon: <Building2 className="w-6 h-6 text-[#00E676]" data-id="element-498" />,
    title: t('value.feature1.title'),
    description: t('value.feature1.desc')
  }, {
    icon: <Briefcase className="w-6 h-6 text-[#00E676]" data-id="element-499" />,
    title: t('value.feature2.title'),
    description: t('value.feature2.desc')
  }, {
    icon: <Zap className="w-6 h-6 text-[#00E676]" data-id="element-500" />,
    title: t('value.feature3.title'),
    description: t('value.feature3.desc')
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-[#00E676]" data-id="element-501" />,
    title: t('value.feature4.title'),
    description: t('value.feature4.desc')
  }];
  return <section className="py-20 bg-white overflow-hidden" data-id="element-502">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-503">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-504">
          {/* Left Content */}
          <div className="order-2 lg:order-1" data-id="element-505">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-506">
              {t('value.title')}{' '}
              <span className="text-[#00E676]" data-id="element-507">
                {t('value.titleHighlight')}
              </span>
              .
            </h2>
            <p className="text-lg text-gray-600 mb-10 leading-relaxed" data-id="element-508">
              {t('value.subtitle')}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-509">
              {features.map((feature, index) => <div key={index} className="flex flex-col items-start" data-id="element-510">
                  <div className="p-3 bg-green-50 rounded-lg mb-4" data-id="element-511">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-512">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-513">{feature.description}</p>
                </div>)}
            </div>
          </div>

          {/* Right Content - Image with Floating Cards */}
          <div className="order-1 lg:order-2 relative" data-id="element-514">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-515">
              <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Professionals discussing document" className="w-full h-full object-cover" data-id="element-516" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-517"></div>
            </div>

            {/* Floating Cards */}
            <div className="absolute top-10 -left-6 bg-white p-4 rounded-lg shadow-xl border-l-4 border-[#00E676] hidden md:block" data-id="element-518">
              <p className="text-xs text-gray-500 uppercase font-semibold" data-id="element-519">
                Status
              </p>
              <p className="text-lg font-bold text-gray-900" data-id="element-520">
                $250,000 Approved
              </p>
            </div>

            <div className="absolute bottom-20 -right-6 bg-white p-4 rounded-lg shadow-xl border-l-4 border-[#00E676] hidden md:block" data-id="element-521">
              <p className="text-xs text-gray-500 uppercase font-semibold" data-id="element-522">
                New LLC
              </p>
              <p className="text-lg font-bold text-gray-900" data-id="element-523">$75,000 Funded</p>
            </div>

            <div className="absolute bottom-10 -left-10 bg-white p-4 rounded-lg shadow-xl border-l-4 border-[#00E676] hidden md:block" data-id="element-524">
              <p className="text-xs text-gray-500 uppercase font-semibold" data-id="element-525">
                Working Capital
              </p>
              <p className="text-lg font-bold text-gray-900" data-id="element-526">$120,000 Sent</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}